export default function initGeolocationPosition(successCallback, errorCallback, browserErrorCallback) {
    if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(successCallback, errorCallback, {
            enableHighAccuracy: true,
            timeout: 60000,
            maximumAge: 3600000,
        });
    } else {
        browserErrorCallback();
    }
}
